import { Hero } from './components/Hero'
import { Features } from './components/Features'
import { ComingSoon } from './components/ComingSoon'
import { Footer } from './components/Footer'
import { Header } from './components/Header'

function App() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Header />
      <main className="flex-grow">
        <Hero />
        <Features />
        <ComingSoon />
      </main>
      <Footer />
    </div>
  )
}

export default App
